import { Card, InputSelectControl } from '@sequencehq/core-components'
import { Box, Flex } from '@chakra-ui/react'
import { Lato13Regular, Lato14Bold } from '@sequencehq/design-tokens'
import { useQuery } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { AvalaraCompanies } from 'Integrations/domain'
import { useState } from 'react'

interface Props {
  avalaraCompanies?: AvalaraCompanies
  enabledAvalaraCompanyId?: string
  setAvalaraCompany: (value: string) => void
}

const AvalaraCompanyCard = ({
  avalaraCompanies: externalAvalaraCompanies,
  enabledAvalaraCompanyId,
  setAvalaraCompany
}: Props) => {
  const isFirstTimeSetup = !enabledAvalaraCompanyId

  const { data } = useQuery(
    dashboardv99990101Client.getAllAvalaraCompanies,
    undefined,
    {
      enabled: !isFirstTimeSetup,
      select: response => response?.items ?? []
    }
  )

  const isSelectDisabled = isFirstTimeSetup && !externalAvalaraCompanies

  const avalaraCompanies = externalAvalaraCompanies || data || []

  const avalaraCompaniesOptions = avalaraCompanies.map(company => ({
    label: company.companyName,
    value: company.id
  }))

  const avalaraCompanyIdFromConfiguration = avalaraCompanies.find(
    company => company.companyId === enabledAvalaraCompanyId
  )?.id

  // Because the whole integration page is wrapped in a context, it gets rerenered and we lose `initialValue` on the `InputSelectControl`
  // this way we can preserve it to show the actually selected company inside the dropdown
  const [internalSelectedCompanyId, setInternalSelectedCompanyId] = useState(
    avalaraCompanyIdFromConfiguration
  )

  const initialValue =
    internalSelectedCompanyId !== enabledAvalaraCompanyId
      ? internalSelectedCompanyId
      : enabledAvalaraCompanyId

  return (
    <Card>
      <Box>
        <Box {...Lato14Bold} mb={2}>
          Avalara company
        </Box>
        <Box {...Lato13Regular} mb={2}>
          Link to the corresponding company in Avalara for this merchant.
        </Box>
        <Flex>
          <InputSelectControl
            data-testid="avalaraCompany.select"
            options={avalaraCompaniesOptions}
            initialValue={initialValue}
            onChange={(companyId: string) => {
              setAvalaraCompany(companyId)
              setInternalSelectedCompanyId(companyId)
            }}
            disabled={isSelectDisabled}
            placeholder="Select a company..."
          />
        </Flex>
      </Box>
    </Card>
  )
}

export default AvalaraCompanyCard
